<template>
  <TIcon
    name="loader"
    class="inline h-12 w-12 animate-spin"
    :class="{
      'text-primary-foreground': variant === 'primary',
      'text-neutral-700': variant === 'neutral',
    }"
  />
</template>
<script lang="ts" setup>
import TIcon from './Icon/TIcon.vue';
withDefaults(defineProps<{ variant?: 'primary' | 'neutral' }>(), {
  variant: 'primary',
});
</script>
